const swiper_used_car_thumb = new Swiper('.swiper_used_car_thumb', {
  loop: true,
  slidesPerView: 4,
  spaceBetween: 8,
  breakpoints: {
    768: {
      slidesPerView: 18,
      loop: false,
      spaceBetween: 0,
    },
  },
});

const swiper_used_car_main = new Swiper('.swiper_used_car_main__content', {
  autoplay: {
    delay: 4000,
  },
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.used_carNext',
    prevEl: '.used_carPrev',
  },
  thumbs: {
    swiper: swiper_used_car_thumb,
  },
});
